import { Directive,Input, HostListener, ElementRef} from '@angular/core';
import { UtilService } from '../util.service';
declare var $: any;
declare var numeral: any;

@Directive({
  selector: '[keys-permitidos]'
})
export class KeyPermitidosDirective {
  private el: HTMLInputElement

  @Input() keyPermitidos: Array<number>;
  @Input() permiteNumero: boolean = false;
  @Input() permiteLetras: boolean = false;
  @Input() formatarNumero: boolean = false;
  @Input() formatoNumero: string = '0,0.00';
  @Input() permiteSinalPositivo: boolean = false;
  @Input() permiteSinalNegativo: boolean = false;
  @Input() permiteNumeroDecimal: boolean = false;

  constructor(private ref: ElementRef) {
    this.el = this.ref.nativeElement;
    numeral.locale('pt-br');
  }

  @HostListener('blur', ['$event.target.value'])
  onblur(value: any) {
    if(this.formatarNumero){
      let numero: number = UtilService.stringToFloat(value);
      if(!isNaN(numero)){
        if((this.permiteSinalPositivo) && (numero > 0)){
          this.el.value = new numeral(numero).format(this.permiteSinalPositivo ? '+' + this.formatoNumero : this.formatoNumero);
        }else{
          this.el.value = new numeral(numero).format(this.formatoNumero);
        }
      }else{
        this.el.value = '';
      }
    }
  }

  @HostListener('keydown', ['$event'])
  onkeydown(e: any) {
    //Pega a tecla digitada
    let keyCode = e.which;
    let ShiftPress = e.shiftKey;
    let CtrlPress  = e.ctrlKey;
    let type =  e.type;
    let value = e.target.value;

    //teclas adicionais permitidas (backspace,tab,seta left,seta right, delete, home, end)
    let keyCodesPermitidos = new Array(8,9,32,37,39,40,41,46,35,36);

    if(this.keyPermitidos != undefined && this.keyPermitidos != null && this.keyPermitidos.length > 0){
      for (let index = 0; index < this.keyPermitidos.length; index++) {
        keyCodesPermitidos.push(this.keyPermitidos[index]);
      }
    }

    if(this.permiteSinalPositivo){
      if(keyCodesPermitidos.indexOf(107) == -1){
        keyCodesPermitidos.push(107);
      }
    }

    if(this.permiteSinalNegativo){
      if(keyCodesPermitidos.indexOf(109) == -1){
        keyCodesPermitidos.push(109);
      }

      if(keyCodesPermitidos.indexOf(189) == -1){
        keyCodesPermitidos.push(189);
      }

    }

    if(this.permiteNumeroDecimal){
      if(keyCodesPermitidos.indexOf(110) == -1){
        keyCodesPermitidos.push(110);
      }

      if(keyCodesPermitidos.indexOf(187) == -1){
        keyCodesPermitidos.push(187);
      }
    }

    if(this.permiteNumero){
    //numeros e 0 a 9 do teclado alfanumerico
      for(let x=48;x<=57;x++){
        keyCodesPermitidos.push(x);
      }

      //numeros e 0 a 9 do teclado numerico
      for(let x=96;x<=105;x++){
          keyCodesPermitidos.push(x);
      }
    }

    if(this.permiteLetras){
      for(let x=65;x<=90;x++){
        keyCodesPermitidos.push(x);
      }
    }

    if((this.permiteSinalPositivo) && (value.indexOf('+') >= 0) && ((keyCode == 107) || (keyCode == 187))){
      return false;
    }

    if((this.permiteSinalNegativo) && (value.indexOf('-') >= 0) && ((keyCode == 109) || (keyCode == 189))){
      return false;
    }

    if((this.permiteNumeroDecimal) && (value.indexOf(',') >= 0) && (keyCode == 110)){
      return false;
    }


    //tratamento para evitar o ====
    if ((!ShiftPress) && keyCode == 187){
      return false;
    }

    //tratamento para evitar o ____
    if ((ShiftPress) && keyCode == 189){
      return false;
    }

    //Verifica se a tecla digitada é permitida
    if ($.inArray(keyCode,keyCodesPermitidos) != -1){
        return true;
    }
    return false;

  }
}



// WEBPACK FOOTER //
// ./src/app/util/directives/key-permitidos.directive.ts